import React, { useState } from 'react';
import PracticeSelector from '../components/PracticeSelector';
import LoginForm from '../components/LoginForm.jsx';

const App = () => {
  const [practice, setPractice] = useState(null);

  if (!practice) {
    return (
      <div className="container py-3">
        <PracticeSelector onPracticeSelect={(p) => setPractice(p)} />
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: 480 }}>
      <button
        type="button"
        onClick={() => setPractice(null)}
        className="btn btn-link p-0 mb-2"
      >
        ← Change practice
      </button>
      <div className="mb-3">
        <div className="h5 mb-1">{practice.name}</div>
        <div className="text-muted small">{practice.address} · PIN {practice.pin}</div>
      </div>
      <LoginForm orgPin={practice.pin} />
    </div>
  );
};

export default App;

